import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { VideoPlayIcon } from '../../../utils/FontIcon';
import {ShowMoreText} from '../../shared';

function VideoCard({
    idx,
    video,
    checked = false,
    handelSelected = () => { },
    handleOpenModal = () => { },
    getRefrence = () => { },
    checkVideoPath = () => true
}) {
    const description = video.description ? video.description : 'No description available.'
    return (
        <Row className='p-2' key={`video_${idx}`} style={{alignItems:'flex-start',boxSizing:'border-box'}}>
            <Col xs={1} className='listed-videos-checkbox'>
                <Form.Check type="checkbox" checked={checked} onChange={(e) => {
                    handelSelected(video);
                }} />
            </Col>
            <Col xs={3}>
                <a
                    href="#"
                    onClick={e => {
                        handleOpenModal(video);
                    }}
                    title={checkVideoPath(video.videoUrl) ? video.title : 'Video will shown in sometime'}
                    style={{ cursor: 'pointer', position: 'relative', display: 'flex', gap: '10px', textDecoration: 'none' }}
                >
                    {checkVideoPath(video.videoUrl) ?
                        <span className='p-relative small-thumb-list'>
                            <img src={video.thumbnailUrl} alt={video.title} className='img-fluid video-thumnail' />
                            <VideoPlayIcon className='video-playbtn'/>
                        </span>
                        :
                        <span className='p-relative small-thumb-list'>
                            <img src='/lms/img/defaultthumb.jpg' alt={video.title} className='img-fluid video-thumnail'/>
                        </span>
                    }
                </a>
            </Col>
            <Col xs={7} className='p0'>
                <span className='fw-600 d-block'>{video.title}</span>
                <div className='text-muted small mb-2'>
                     <ShowMoreText text={description} styleClass='inline-block' />
                </div>
               
                {getRefrence(video, idx)}
            </Col>
        </Row>

    );
}

export default VideoCard;